import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { navigationActions } from 'store/navigationSlice.js';

import { useOnScreen } from './useOnScreen';

export const useNav = navLinkId => {
  const ref = useRef(null);
  const dispatch = useDispatch();
  const clickAction = useSelector(state => state.navigation.clickAction);

  const isOnScreen = useOnScreen(ref);

  useEffect(() => {
    if (isOnScreen && !clickAction) {
      dispatch(navigationActions.setActiveNavLinkId(navLinkId));
    }
  }, [isOnScreen, navLinkId]);

  return ref;
};
